module.exports = __webpack_public_path__ + "static/media/artwork.d7267533.jpg";